import { useContext } from 'react'
import { Button, ButtonGroup, Text } from '@leroy-merlin-br/backyard-react-ui'

import { useProfile } from 'catalog/hooks/use-profile'

import { EntryKeyContext } from '../../../../context/EntryKeyContext'
import { CleanFiltersButton } from '../../../CleanFiltersButton'
import { StockFilter } from '../../../StockFilter'
import * as S from './styled'

const Footer = () => {
  const {
    metadata: { totalCount },
    toggleMobileFilter,
    scrollToTop
  } = useContext(EntryKeyContext)

  const handleFilterClick = () => {
    toggleMobileFilter()
    scrollToTop()
  }
  const { isAssistedSale } = useProfile()

  const totalProducts = () => {
    const label =
      totalCount === 1 ? 'Produto encontrado' : 'Produtos encontrados'
    const value = totalCount?.toLocaleString('pt-BR')

    return { label, value }
  }

  const { label, value } = totalProducts()

  return (
    <S.Footer>
      <S.Stack spacing="giga">
         {isAssistedSale && <StockFilter />}

        <S.TotalProducts>
          <Text size="mega" as="span" bold noMargin>
            {value}{' '}
          </Text>
          <Text size="mega" as="span" bold noMargin>
            {label}
          </Text>
        </S.TotalProducts>

        <ButtonGroup label="botões de filtros" align="center" inlineMobile>
          <CleanFiltersButton />
          <Button size="mega" onClick={handleFilterClick}>
            Aplicar filtros
          </Button>
        </ButtonGroup>
      </S.Stack>
    </S.Footer>
  )
}

export default Footer
